export default "__VITE_ASSET__HeN1QON$__";